import { get } from "aws-amplify/api";

const readJsonBody = async (body: unknown): Promise<unknown> => {
  if (!body || typeof body !== "object") return {};
  if ("json" in body && typeof body.json === "function") {
    return await body.json();
  }
  if ("text" in body && typeof body.text === "function") {
    try {
      return JSON.parse(await body.text());
    } catch {
      return {};
    }
  }
  return body;
};

export const OtaApi = {
  /**
   * Retrieves competitor rates for a given OTA hotel and date range
   */
  getRates: async (
    otaHotelId: number,
    startDate: string,
    endDate: string,
  ): Promise<Record<string, unknown>> => {
    try {
      const { body } = await get({
        apiName: "ota",
        path: `/${otaHotelId}/rates/${startDate}/${endDate}`,
      }).response;
      const result = await readJsonBody(body);
      return result && typeof result === "object"
        ? (result as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  },

  /**
   * Retrieves market demand for a given OTA hotel and date range
   */
  getDemand: async (
    otaHotelId: number,
    startDate: string,
    endDate: string,
  ): Promise<Record<string, { demand?: number }>> => {
    try {
      const { body } = await get({
        apiName: "ota",
        path: `/${otaHotelId}/demand/${startDate}/${endDate}`,
      }).response;
      const result = await readJsonBody(body);
      return result && typeof result === "object"
        ? (result as Record<string, { demand?: number }>)
        : {};
    } catch {
      return {};
    }
  },

  /**
   * Retrieves rate and demand comparison data for a historical pickup date
   */
  getPickupCompare: async (
    otaHotelId: number,
    pickupDate: string,
    startDate: string,
    endDate: string,
  ): Promise<unknown> => {
    try {
      const { body } = await get({
        apiName: "ota",
        path: `/${otaHotelId}/pickup/${pickupDate}/${startDate}/${endDate}`,
      }).response;
      return await readJsonBody(body);
    } catch {
      return {};
    }
  },
};
